export function calculateTextWidth(fontFamilyKey: {}, text: string, defaultWidth = 8) {
  // if(!!text) {
    return text.toString().split('').reduce((acc, curr) => {
      const width = fontFamilyKey[curr] || defaultWidth;
      return acc + width;
    }, 0);
  // } else {
  //   return defaultWidth;
  // }

}
